import type { ComponentProps } from 'react';

type CrossCircleProps = ComponentProps<'svg'> & {
  pathStroke?: string; // Add this line to extend the props
  crossBackground?: string;
};

const CrossCircle = ({
  fill = '#EF4444',
  crossBackground = '#FEE2E2',
  ...props
}: CrossCircleProps) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="32" r="28" fill={crossBackground}></circle>
      <path
        d="M27.105 23.7145C26.2343 22.7618 24.6773 22.7618 23.7145 23.7145C22.7618 24.6773 22.7618 26.2343 23.7145 27.105L28.5391 31.9193L23.7145 36.8259C22.7618 37.7887 22.7618 39.3457 23.7145 40.2164C24.6773 41.2612 26.2343 41.2612 27.105 40.2164L31.9193 35.484L36.8259 40.2164C37.7887 41.2612 39.3457 41.2612 40.2164 40.2164C41.2612 39.3457 41.2612 37.7887 40.2164 36.8259L35.484 31.9193L40.2164 27.105C41.2612 26.2343 41.2612 24.6773 40.2164 23.7145C39.3457 22.7618 37.7887 22.7618 36.8259 23.7145L31.9193 28.5391L27.105 23.7145Z"
        fill={fill}
      ></path>
    </svg>
  );
};

export default CrossCircle;